import React, { useState } from 'react';
import { fromDateTimeLocalValue, toDateTimeLocalValue } from '../../../../../utils/dateUtils';

interface DateTimeInputProps {
  id: string;
  value: string | null | undefined;
  /** Gets the UTC date once the field holds a whole one, or null when it's emptied */
  onChange: (value: string | null) => void;
  disabled?: boolean;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ id, value, onChange, disabled }) => {
  // Browsers report a year as it's typed: its first digit made year 2, which the field couldn't show and apps couldn't
  // read. So an incomplete date is kept as typed, and leaving the field puts the saved one back.
  const [typed, setTyped] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = fromDateTimeLocalValue(e.target.value);
    if (date || !e.target.value) {
      setTyped(null);
      onChange(date);
    } else {
      setTyped(e.target.value);
    }
  };

  return (
    <input
      id={id}
      type="datetime-local"
      value={typed ?? toDateTimeLocalValue(value)}
      onChange={handleChange}
      onBlur={() => setTyped(null)}
      disabled={disabled}
    />
  );
};

export default DateTimeInput;
